module.exports = __webpack_public_path__ + "img/ИФ-1(А)-048-m.ad184227.png";